import React, { useState, useEffect, Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { isAuthenticated } from '../auth';
import { addShippingAddr } from './apiUser';
import loadingIcon from '../images/loading.png';

const AddShippingModal = ({addresses, open, setOpen, setAddresses}) => {
    const cancelButtonRef = useRef(null);
    const { user: {_id}, token } = isAuthenticated();
    const [loading, setLoading] = useState(false);

    const [values, setValues] = useState({
        street1: '',
        name: '',
        city: '',
        state: '',
        zip: '',
        country: 'US',
        error: '',
        success: false
        //add name in the future
    });
    const { street1, name, city, state, zip, country, error, success } = values;

    const handleChange = name => event => {
        setValues({...values, error: false, [name]: event.target.value});
    };

    const clickSubmit = event => {
        setLoading(true);
        const shipping_address = {
            name: name,
            street1: street1,
            city: city,
            state: state,
            zip: zip,
            country: country
        };

        event.preventDefault();
        setValues({...values, error: false});
        addShippingAddr(_id, token, shipping_address)
            .then(data => {
                console.log(data);
                if (data.error) {
                    console.log(data.error);
                    setValues({...values, error: data.error, success:false});
                }
                else {
                    setOpen(false);
                    setAddresses(addresses => [...addresses, data.addr]);
                    setValues({
                        ...values,
                        name: '',
                        street1: '',
                        city: '',
                        state: '',
                        zip: '',
                        error: '',
                        success: true
                    });
                }
                setLoading(false);
            });
    };

    const ShowLoading = () => (
        <div className="rounded-md p-4" style={{display: loading ? '' : 'none'}}>
<div class="flex items-center justify-center space-x-2 animate-bounce">
    <div class="w-4 h-4 bg-blue-400 rounded-full"></div>
    <div class="w-4 h-4 bg-blue-400 rounded-full"></div>
    <div class="w-4 h-4 bg-blue-400 rounded-full"></div>
</div>
        </div>
    );

    const ShowError = () => (
        <div className="rounded-md bg-red-50 p-4 " style={{display: error ? '' : 'none'}}>
            <div className="flex">
                <div className="flex-shrink-0">
                </div>
                <div className="ml-3">
                    <div className="text-sm text-red-700 font-medium text-left">
                        <p className='pl-5 space-y-1'> {error} </p>
                    </div>
                </div>
            </div>
        </div>
    );


    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={setOpen}>
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                            <div>

                                <div className="mt-1 text-center sm:mt-5">
                                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                        Add Shipping Address
                                    </Dialog.Title>

                                    <ShowLoading/>
                                    <ShowError/>
                                    <div className="mt-2">
                                        {/* form here */}
                                        <div className="relative border border-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600 mt-3">
                                            <label
                                                htmlFor="name"
                                                className="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-gray-900"
                                            >
                                                First and Last name
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                id="name"
                                                className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
                                                onChange={handleChange('name')}
                                                value={name}
                                            />
                                        </div>

                                        <div className="relative border border-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600 mt-3">
                                            <label
                                                htmlFor="name"
                                                className="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-gray-900"
                                            >
                                                Street
                                            </label>
                                            <input
                                                type="text"
                                                name="street1"
                                                id="street1"
                                                className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
                                                onChange={handleChange('street1')}
                                                value={street1}
                                            />
                                        </div>

                                        <div className="relative border border-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600 mt-3">
                                            <label
                                                htmlFor="name"
                                                className="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-gray-900"
                                            >
                                                City
                                            </label>
                                            <input
                                                type="text"
                                                name="city"
                                                id="city"
                                                className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
                                                onChange={handleChange('city')}
                                                value={city}
                                            />
                                        </div>

                                        <div className="relative border border-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600 mt-3">
                                            <label
                                                htmlFor="name"
                                                className="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-gray-900"
                                            >
                                                State
                                            </label>
                                            <input
                                                type="text"
                                                name="state"
                                                id="state"
                                                className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
                                                onChange={handleChange('state')}
                                                value={state}
                                            />
                                        </div>

                                        <div className="relative border border-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600 mt-3">
                                            <label
                                                htmlFor="name"
                                                className="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-gray-900"
                                            >
                                                Zip
                                            </label>
                                            <input
                                                type="text"
                                                name="zip"
                                                id="zip"
                                                className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
                                                onChange={handleChange('zip')}
                                                value={zip}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                <button
                                    type="button"
                                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                                    onClick={clickSubmit}
                                >
                                    Submit
                                </button>
                                <button
                                    type="button"
                                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                                    onClick={() => setOpen(false)}
                                    ref={cancelButtonRef}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>

    );
}

export default AddShippingModal;
